import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseService } from '../../../base/base.service';
import { Config } from '../../../models/Config';
@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {

  httpClient = inject(HttpClient);
  constructor() {
    super();
  }

    /*
     *   function name: despositEntry()
     *   functionality: ownership master deatails
     *   parameters : {}
     */
    dashboardfilter(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_colloection_dash`, data, this.getConfig())
    }

    saleDashboard(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_sale_amount_dash`, data, this.getConfig())
    }
    getsaleDashboard() {
      return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_sale_amount_bar`, this.getConfig())
    }
    saleAmountDashboard(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_sale_amount_bar`, data, this.getConfig())
    }
    
      
    getStationDash(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/cng_station_dash`,data, this.getConfig())
    }
    getColloctionDash() {
      return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_colloection_dash`, this.getConfig())
    }
    dashboardStationTypeWiseQtyfilter(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/get_cng_station_type_wise_qty`, data, this.getConfig())
    }
    dashboardOwnershipTypeWisefilter(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/get_cng_ownership_type_wise`, data, this.getConfig())
    }
    dashboardMomentTypeWisefilter(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/get_cng_moment_type_wise`, data, this.getConfig())
    }
    
    /*
    *   function name: getdespositEntry()
    *   functionality: ownership master deatails
    *   parameters : {}
    */
    getdespositEntry() {
      return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/get_cng_deposit_entry`, this.getConfig())
    }
  
    dashboardfilterSoldQtyByStationType(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/sold_Qty_By_Station_Type`, data, this.getConfig())
    }
    soldQtyByDayWiseStationType(data: any) {
      return this.httpClient.post<Config>(`${this.getAppBaseUrl()}/sold_qty_by_day_Station_type`, data, this.getConfig())
    }
    dashboardTrends() {
      return this.httpClient.get<Config>(`${this.getAppBaseUrl()}/cng_trends`, this.getConfig())
    }

}
